import React from "react";

export default function EmptyState({ title, description, action }) {
  return (
    <div className="vp-empty-state">
      <div className="vp-empty-state-title">{title}</div>
      {description ? <p className="vp-empty-state-desc">{description}</p> : null}
      {action ? <div className="vp-empty-state-action">{action}</div> : null}
    </div>
  );
}
